import React from "react";

/** Phosphor-style X (same geometry as `public/img/x.svg`). */
const MODAL_X_VIEWBOX = "0 0 256 256";
const MODAL_X_PATH =
  "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z";

/** Default glyph size for modal close controls — large enough to read at a glance. */
export const MODAL_CLOSE_ICON_SIZE = 28;

/**
 * Shared close (X) icon for modals. Use with ModalCloseButton for a full button,
 * or render this icon directly inside your own button.
 */
export function ModalCloseIcon({
  className = "",
  width = MODAL_CLOSE_ICON_SIZE,
  height = MODAL_CLOSE_ICON_SIZE,
  fill = "#fff",
}) {
  return (
    <svg
      className={className}
      fill={fill}
      height={height}
      width={width}
      viewBox={MODAL_X_VIEWBOX}
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={MODAL_X_PATH} />
    </svg>
  );
}

/**
 * Shared close button for modals. Renders a button with ModalCloseIcon inside.
 * Large default hit target + glyph so dismiss is easy to find and tap.
 */
export function ModalCloseButton({
  onClick,
  className = "",
  ariaLabel = "Close",
  iconSize = MODAL_CLOSE_ICON_SIZE,
}) {
  return (
    <button
      type="button"
      className={`flex min-h-11 min-w-11 shrink-0 cursor-pointer items-center justify-center text-white hover:opacity-80 ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <ModalCloseIcon width={iconSize} height={iconSize} fill="currentColor" />
    </button>
  );
}

export default ModalCloseIcon;
